/*
 * File: /src/services/whatsappService.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 27th June 2019 4:08:11 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { S2_AIRBNB_PATH, AD_BASE_USER_PATH } from '../constants';

export default {

  // Pulls the latest threads for any contacts that meet the critera.
  // Used to populate the list of contacts on the inbox thread view
  fetchThreads(limit, offset, filters, sort, unassigned, incomplete, assignee, brandIds, beforeDate, airbnbType, search) {
    if (filters == undefined) {
      filters = [];
    }
    /*
    // const filters = ['direction:eq:inbound'];
    if (contactId) {
      filters.push(`contact_id:eq:${contactId}`);
    }
    */

    const params = {
      filter: filters.length ? filters : undefined,
      sort: sort,
      limit: limit,
      offset: offset,
      unassigned: unassigned,
      incomplete: incomplete,
      assignee: assignee,
      brand_ids: brandIds,
      before_date: beforeDate,
      airbnb_type: airbnbType,
      nameSearch: search,
    };
    if (beforeDate) {
      params.before_date = beforeDate;
      // params.before_id = beforeId;
    }
    /*
    if (afterId) {
      params.after_id = afterId;
    }
    */

    return authedAxios.get(S2_AIRBNB_PATH + 'threads/', {params: params});
  },

  /**
   * Fetch Messages, by thread or contact mostly.
   * Used to fill the thread message details
   */
  fetchMessages(limit, offset, sort, filters, unassigned, incomplete, assignee, brandIds, beforeId) {
    const params = {
      filter: filters.length ? filters : undefined,
      sort: sort,
      limit: limit,
      offset: offset,
      unassigned: unassigned,
      incomplete: incomplete,
      assignee: assignee,
      brand_ids: brandIds,
      before_id: beforeId,
    };
    /* Not build yet
    if (beforeDate) {
      params.before_date = beforeDate;
      params.before_id = beforeId;
    }
    if (afterId) {
      params.after_id = afterId;
    }
    */

    return authedAxios.get(S2_AIRBNB_PATH, { params: params });
  },

  getThread(threadId) {
    return authedAxios.get(S2_AIRBNB_PATH + 'threads/' + threadId);
  },

  getMessage(messageId) {
    return authedAxios.get(S2_AIRBNB_PATH + messageId);
  },


  /**
   * Send Message
   *
   * @param {*} contact_id
   * @param {*} msg
   * @param {*} service_id
   * @returns
   */
  sendMessage(contact_id, msg, number_id, attachments, threadId, accountId, airbnbUserId, reservationId) {
    return authedAxios.post(S2_AIRBNB_PATH + 'send/', {
      contact_id: contact_id,
      message: msg,
      from_number_id: number_id,
      attachments: attachments ? attachments : [],
      thread_id: threadId,
      airbnb_account_id: accountId,
      airbnb_user_id: airbnbUserId,
      reservation_id: reservationId,
    });
  },


  setLastSeen(id) {
    // THis is a one off on the user controller
    return authedAxios.put(AD_BASE_USER_PATH + 'lastseen-airbnb/' + id);
  },
  assign(id, userId) {
    const payload = { user_id: userId };
    return authedAxios
      .put(S2_AIRBNB_PATH + 'assign/' + id, payload)
      .then(r => r.data);
  },
  markCompleted(id) {
    return authedAxios
      .put(S2_AIRBNB_PATH + 'markcompleted/' + id)
      .then(r => r.data);
  },

  fetchAccounts() {
    return authedAxios.get(S2_AIRBNB_PATH  + 'accounts');
  },
  registerAirbnb(code, phoneId, wabaId) {
    // NOt sure we get the rest
    return authedAxios.post(S2_AIRBNB_PATH  + 'register',
      {code: code});
  },
  setBrand(accountId, brandId) {
    return authedAxios.post(S2_AIRBNB_PATH  + accountId +  '/brand',
      {brand_id: brandId});
  },
  setName(accountId, name) {
    return authedAxios.put(S2_AIRBNB_PATH  + accountId +  '/name',
      {name: name});
  },
  deleteAccount(accountId) {
    return authedAxios.delete(S2_AIRBNB_PATH  + accountId);
  },

};
